import { IfspHealthSummaryReportType } from '../../../../redux/features/ifsp/ifspHealthSummarySlice';
import { datePickerMinDateMaxDateValidate } from '../../../../utils/dateUtil';

export type ReportTabValidationType = {
  dateOfEligibilityEvaluation?: boolean;
  dateOfEligibilityEvaluationErrorMessageId?: string;
  dateOfEligibilityEvaluationErrorMessage?: string;
  dateOfEligibilityEvaluationErrorIndex?: number[] | null;
  reportcompletedBy?: boolean;
  reportcompletedByErrorMessageId?: string;
  reportcompletedByErrorMessage?: string;
  reportCompletedByRole?: boolean;
  reportCompletedByRoleErrorMessageId?: string;
  reportCompletedByRoleErrorMessage?: string;
};

export const useIfspReportValidationCheckToSubmit = ({
  healthSummary,
}: IfspHealthSummaryReportType): ReportTabValidationType => {
  const validationResult: ReportTabValidationType = {};

  //  =============== Date of Eligibility Evaluation ===============
  const eligibilityErrors: number[] = [];

  healthSummary.forEach((item, index) => {
    if (datePickerMinDateMaxDateValidate(item.eligibilityDateEvaluation)) {
      eligibilityErrors.push(index);
    }
  });

  if (eligibilityErrors.length > 0) {
    Object.assign(validationResult, {
      dateOfEligibilityEvaluation: true,
      dateOfEligibilityEvaluationErrorMessageId:
        'datePickerMinDateMaxDateValidate',
      dateOfEligibilityEvaluationErrorMessage:
        'Date of Eligibility Evaluation is invalid',
      dateOfEligibilityEvaluationErrorIndex: eligibilityErrors,
    });
  }

  return validationResult;
};
